import { Tgt_Inst } from './tgt_inst';
import { Tgt_Attr_Lnk } from './tgt_attr_lnk';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { DObj } from './dobj';
import { RepConn } from '../datapoint/repconn';
import { DxMp_Fwd_Lnk } from './dxmp_fwd_lnk.';
import { CommonEnums } from '../../common.enums';
import { DObjsUtil } from '../../utils/dobjs.util';
import { DxMp_Fwd_LnksUtil } from '../../utils/dxmp_fwd_lnks.util';
import { Tgt_Attr_LnksUtil } from '../../utils/tgt_attr_lnks.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from '../../utils/db_propertytypes.util';
import { ArrayUtil } from '../utils/array.util';

export class TargetConnect {
	tgt_Inst: Tgt_Inst;
	tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>;
	sink_Properties: Array<Obj_Db_Property>;
	nativeDbTyp_Id: number;
	change_Ind: string;
	error_Cd: string;
	error_Msg: string;
	ref_Id: number;
	ref_Cd: string;
	fldr_Id: number;
	imageUrl: string;
	sel_Load_PropertyType_Cd: string;
	loadPropertyTypes: Array<Db_PropertyType>;
	isNativeFlg: boolean;
	srcTgt_RelationIds: Array<number>
	dObjs: Array<DObj>;
	repConn: RepConn;
	tgtSrcLnks: Array<DxMp_Fwd_Lnk>;
	tgtDObjLnks: Array<DxMp_Fwd_Lnk>;

	constructor() {
		this.setDefaults()
	}

	setDefaults() {
		this.tgt_Inst = new Tgt_Inst();
		this.dObjs = new Array<DObj>();
		this.tgtSrcLnks = new Array<DxMp_Fwd_Lnk>();
		this.tgtDObjLnks = new Array<DxMp_Fwd_Lnk>();
		this.repConn = new RepConn();
		this.tgt_Attr_Lnks = new Array<Tgt_Attr_Lnk>();
		this.sink_Properties = new Array<Obj_Db_Property>();
		this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
		this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
		this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
		this.ref_Id = CommonEnums.defaults.LONG_VAL;
		this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.fldr_Id = CommonEnums.defaults.LONG_VAL;
		this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
		this.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.loadPropertyTypes = new Array<Db_PropertyType>();
		this.isNativeFlg = true;
		this.srcTgt_RelationIds = new Array<number>();
	}

	static parse(targetConnectTmp: TargetConnect): TargetConnect {
		let targetConnect: TargetConnect = new TargetConnect();
		targetConnect.copyFrom(targetConnectTmp);
		return targetConnect;
	}

	copy(): TargetConnect {
		let targetConnectTmp: TargetConnect = new TargetConnect()

		targetConnectTmp.tgt_Inst = this.tgt_Inst.copy();
		targetConnectTmp.dObjs = DObjsUtil.getInstance().copy(this.dObjs);
		targetConnectTmp.tgtSrcLnks = DxMp_Fwd_LnksUtil.getInstance().copy(this.tgtSrcLnks);
		targetConnectTmp.tgtDObjLnks = DxMp_Fwd_LnksUtil.getInstance().copy(this.tgtDObjLnks);
		targetConnectTmp.repConn = this.repConn;
		targetConnectTmp.tgt_Attr_Lnks = Tgt_Attr_LnksUtil.getInstance().copy(this.tgt_Attr_Lnks);
		targetConnectTmp.sink_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.sink_Properties);
		targetConnectTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
		targetConnectTmp.change_Ind = this.change_Ind;
		targetConnectTmp.error_Cd = this.error_Cd;
		targetConnectTmp.error_Msg = this.error_Msg;
		targetConnectTmp.ref_Id = this.ref_Id;
		targetConnectTmp.ref_Cd = this.ref_Cd;
		targetConnectTmp.fldr_Id = this.fldr_Id;
		targetConnectTmp.imageUrl = this.imageUrl;
		targetConnectTmp.sel_Load_PropertyType_Cd = this.sel_Load_PropertyType_Cd;
		targetConnectTmp.loadPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.loadPropertyTypes);
		targetConnectTmp.isNativeFlg = this.isNativeFlg;
		targetConnectTmp.srcTgt_RelationIds = ArrayUtil.getInstance().copy(this.srcTgt_RelationIds);

		return targetConnectTmp;
	}

	copyFrom(targetConnectTmp: TargetConnect): void {
		this.tgt_Inst.copyFrom(targetConnectTmp.tgt_Inst);
		DObjsUtil.getInstance().copyFrom(this.dObjs, targetConnectTmp.dObjs);
		DxMp_Fwd_LnksUtil.getInstance().copyFrom(this.tgtSrcLnks, targetConnectTmp.tgtSrcLnks);
		DxMp_Fwd_LnksUtil.getInstance().copyFrom(this.tgtDObjLnks, targetConnectTmp.tgtDObjLnks);
		this.repConn = targetConnectTmp.repConn;
		Tgt_Attr_LnksUtil.getInstance().copyFrom(this.tgt_Attr_Lnks, targetConnectTmp.tgt_Attr_Lnks);
		let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
		obj_Db_PropertiesUtil.copyFrom(this.sink_Properties, targetConnectTmp.sink_Properties);
		if (this.sink_Properties.length > 0) {
			obj_Db_PropertiesUtil.setShowOn(this.sink_Properties, true, this.sink_Properties[0].propertyType_Cd);
			obj_Db_PropertiesUtil.setShowOn(this.sink_Properties, false, this.sink_Properties[0].propertyType_Cd);
		}
		this.nativeDbTyp_Id = targetConnectTmp.nativeDbTyp_Id;
		this.change_Ind = targetConnectTmp.change_Ind;
		this.error_Cd = targetConnectTmp.error_Cd;
		this.error_Msg = targetConnectTmp.error_Msg;
		this.ref_Id = targetConnectTmp.ref_Id;
		this.ref_Cd = targetConnectTmp.ref_Cd;
		this.fldr_Id = targetConnectTmp.fldr_Id;
		this.imageUrl = targetConnectTmp.imageUrl;
		this.sel_Load_PropertyType_Cd = targetConnectTmp.sel_Load_PropertyType_Cd;
		Db_PropertyTypesUtil.getInstance().copyFrom(this.loadPropertyTypes, targetConnectTmp.loadPropertyTypes);
		this.isNativeFlg = targetConnectTmp.isNativeFlg;
		//ArrayUtil.getInstance().copyFrom(this.srcTgt_RelationIds, targetConnectTmp.srcTgt_RelationIds);
	}

	compare(targetConnectTmp: TargetConnect): string {
		let targetConnectString: string = this.toString(false);
		let targetConnectTmpString: string = targetConnectTmp.toString(false);

		if (targetConnectString != targetConnectTmpString) {
			return targetConnectString + ', ' + targetConnectTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
		let dObjsUtil: DObjsUtil = DObjsUtil.getInstance();
		let dxMp_Fwd_LnksUtil: DxMp_Fwd_LnksUtil = DxMp_Fwd_LnksUtil.getInstance();
		let tgt_Attr_LnksUtil: Tgt_Attr_LnksUtil = Tgt_Attr_LnksUtil.getInstance();
		let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
		let arrayUtil: ArrayUtil = ArrayUtil.getInstance();

		let str: string = "tgt_Inst [nm=" + this.tgt_Inst.toString() +
			", dObjs=" + dObjsUtil.toString(this.dObjs) +
			", tgtSrcLnks=" + dxMp_Fwd_LnksUtil.toString(this.tgtSrcLnks) +
			", tgtDObjLnks=" + dxMp_Fwd_LnksUtil.toString(this.tgtDObjLnks) +
			", repConn=" + this.repConn.toString() +
			", tgt_Attr_Lnks=" + tgt_Attr_LnksUtil.toString(this.tgt_Attr_Lnks) +
			", sink_Properties=" + obj_Db_PropertiesUtil.toString(this.sink_Properties) +
			", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
			", error_Cd =" + this.error_Cd +
			", error_Msg =" + this.error_Msg
			+ ",ref_Id =" + this.ref_Id +
			",ref_Cd =" + this.ref_Cd +
			", fldr_Id =" + this.fldr_Id +
			", imageUrl=" + this.imageUrl +
			",sel_Load_PropertyType_Cd=" + this.sel_Load_PropertyType_Cd +
			", loadPropertyTypes =" + db_PropertyTypesUtil.toString(this.loadPropertyTypes) +
			", isNativeFlg=" + this.isNativeFlg;


		if (isNotCompare) {
			str += "change_Ind=" + this.change_Ind + ", srcTgt_RelationIds=" + arrayUtil.toString(this.srcTgt_RelationIds);
		}

		str += ']';
		return str;
	}
}